import { useState, useContext } from 'react'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'
import { ArrowPathRoundedSquareIcon } from '@heroicons/react/20/solid'

import ExerciseImage from 'components/ExerciseImage'

export default function ExerciseOverrideInput({ phaseIndex, slotIndex, exercise }) {

    const { exercises, allowEditing, setModalRoute, setCurrentExercise, setExerciseSwapIndices } = useContext(WorkoutOverrideModalContext)

    const [showSwapIcon, setShowSwapIcon] = useState(false)

    const OnExerciseSwapClicked = () => {
        setCurrentExercise(exercise)
        setExerciseSwapIndices({ 'phaseIndex': phaseIndex, 'slotIndex': slotIndex })
        setModalRoute('current-exercise-instructions')
    }

    return (
        <>
            {allowEditing &&
                <div 
                    className='col-span-2 p-2 flex items-center gap-x-2 cursor-pointer'
                    onMouseEnter={() => setShowSwapIcon(true)}
                    onMouseLeave={() => setShowSwapIcon(false)}
                    onClick={OnExerciseSwapClicked}
                >
                    <div className='relative'>
                        <ExerciseImage
                            exercise={exercise}
                            exercises={exercises}
                        />

                        {showSwapIcon &&
                            <div className='absolute top-0 right-0 p-2 bg-gray-600/50 rounded-md'>
                                <ArrowPathRoundedSquareIcon className='w-8 h-8 text-white' />
                            </div>
                        }
                    </div>

                    <div className='text-left text-sm'>{exercise.name}</div>
                </div>
            }

            {!allowEditing &&
                <div className='col-span-2 p-2 flex items-center gap-x-2'>
                    <div className='relative'>
                        <ExerciseImage
                            exercise={exercise}
                            exercises={exercises}
                        />
                    </div>

                    <div className='text-left text-sm'>{exercise.name}</div>
                </div>
            }
        </>
    )
}